import React from 'react';
import classes from './Backdrop.css';

const backdrop = (props) => {
  const backdropClasses = [classes.Backdrop];
  if (props.show) {
    backdropClasses.push(classes.Show);
  }

  return <div className={backdropClasses.join(' ')} onClick={props.clicked}></div>
}

export default backdrop;


// WEBPACK FOOTER //
// ./src/components/UI/Backdrop/Backdrop.jsx